import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { FontAwesomeBase64 } from './CustomFonts.js';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.vfs['FontAwesome.ttf'] = FontAwesomeBase64;
pdfMake.fonts = {
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf',
  },
  FontAwesome: {
    normal: 'FontAwesome.ttf',
    bold: 'FontAwesome.ttf',
    italics: 'FontAwesome.ttf',
    bolditalics: 'FontAwesome.ttf',
  },
};
dayjs.extend(customParseFormat);
dayjs.locale('fr');

const generatePdf = (planifData, planifDate, selectedRowKeys) => {
  let dd = generateContent(planifData, planifDate, selectedRowKeys);
  pdfMake.createPdf(dd).print();
};

function getColor(project) {
  if (project.remarques === 'OUT') {
    return { background: '#fff7e6', border: '#ffd591', color: '#d46b08' };
  }
  switch (project.depart) {
    case '17:30':
    case '18:00':
    case '18:30':
    case '19:00':
    case '19:30':
    case '20:00':
    case '20:30':
    case '21:00':
    case '21:30':
    case '22:00':
    case '22:30':
    case '23:00':
    case '23:30':
    case '00:00':
    case '00:30':
    case '01:00':
    case '01:30':
    case '02:00':
    case '02:30':
    case '03:00':
    case '03:30':
    case '04:00':
    case '04:30':
      return { background: '#f6ffed', border: '#b7eb8f', color: '#389e0d' };
    case '05:00':
    case '05:30':
    case '06:00':
    case '06:30':
    case '07:00':
    case '07:30':
    case '08:00':
    case '08:30':
    case '09:00':
    case '09:30':
    case '10:00':
    case '10:30':
    case '11:00':
    case '11:30':
    case '12:00':
    case '12:30':
    case '13:00':
    case '13:30':
    case '14:00':
    case '14:30':
    case '15:00':
    case '15:30':
    case '16:00':
    case '16:30':
    case '17:00':
      return { background: '#ffffc7', border: '#eded00', color: '#8c7e00' };
  }
  switch (project) {
    case 'CONGÉ':
      return { background: '#e6f7ff', border: '#91d5ff', color: '#096dd9' };
    case 'OFF':
      return { background: '#fff0f6', border: '#ffadd2', color: '#c41d7f' };
  }
}
function generateContent(planifData, planifDate, selectedRowKeys) {
  console.log(planifData);
  let content = [];
  let datePlanif = `Cédule du ${capitalize(
    dayjs(planifDate, 'D MMMM YYYY').format('dddd')
  )} ${dayjs(planifDate, 'D MMMM YYYY').format('DD')} ${capitalize(
    dayjs(planifDate, 'D MMMM YYYY').format('MMMM')
  )} ${dayjs(planifDate, 'D MMMM YYYY').format('YYYY')}`;
  content.push({ text: datePlanif, bold: true });
  planifData.sort((a, b) => {
    return a.nom.localeCompare(b.nom);
  });
  //console.log(planifData);
  let tableBody = planifData.map((employe) => {
    let employeheure = '';
    let employeremarque = '';
    let color = getColor(employe.projects[0]);
    if (employe.projects[0] === 'CONGÉ') {
      employeheure = 'CONGÉ';
    } else if (employe.projects[0] === 'OFF') {
      employeheure = 'OFF';
    } else {
      employe.projects.forEach((project, index) => {
        if (index > 0) {
          employeheure += '\n';
          employeremarque += '\n';
        }
        employeheure += project.depart;
        employeremarque += project.remarques.replace('.', '');
      });
    }
    return [
      employe.nom,
      employe.prenom,
      { text: employeheure, fillColor: color.border },
      employeremarque,
      buildPrintMessage(employe, selectedRowKeys),
      {
        text: selectedRowKeys.includes(employe.key)
          ? { text: '', style: 'symbol' }
          : '',
        alignment: 'center',
      },
    ];
  });

  content.push({
    layout: 'lightHorizontalLines',
    margin: [0, 20, 0, 0],
    table: {
      headerRows: 1,
      dontBreakRows: true,
      keepWithHeaderRows: 1,
      widths: ['auto', 'auto', 'auto', 'auto', '*', 50],
      body: [
        [
          { text: 'NOM', bold: true },
          { text: 'PRENOM', bold: true },
          { text: 'HEURE', bold: true },
          { text: 'REMARQUE', bold: true },
          { text: 'MESSAGE', bold: true },
          { text: 'CHECK', alignment: 'center', bold: true },
        ],
        ...tableBody,
      ],
    },
  });
  let dd = {
    footer: function (currentPage, pageCount) {
      return {
        text: 'Page ' + currentPage.toString() + ' de ' + pageCount,
        alignment: 'right',
        margin: [20, 0],
      };
    },
    pageSize: 'LETTER',
    pageOrientation: 'landscape',
    pageMargins: [30, 30, 30, 30],
    content: content,
    defaultStyle: {
      font: 'Roboto',
    },
    styles: {},
  };
  dd.styles.symbol = { font: 'FontAwesome' };
  return dd;
}
const buildPrintMessage = (employe, selectedRowKeys) => {
  if (!selectedRowKeys.includes(employe.key)) {
    return '';
  }
  let message;
  if (employe.manualmessage) {
    message = employe.message;
  } else {
    if (employe.projects[0] === 'CONGÉ') {
      return 'CONGÉ';
    } else if (employe.projects[0] === 'OFF') {
      return 'OFF';
    }
    message = { text: '', style: 'symbol' };
    if (employe.direprojet) {
      message.text += ' ';
    }
    if (employe.direcamion) {
      message.text += ' ';
    }
    if (employe.direchauffeur) {
      message.text += ' ';
    }
    if (employe.direchefequipe) {
      message.text += ' ';
    }
    if (employe.direequipe) {
      message.text += ' ';
    }
  }
  return message;
};
const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};
const generatePdfPlanifMultiple = (planifTitles, planifData) => {
  let dd = generateContentPlanifMultiple(planifTitles, planifData);
  pdfMake.createPdf(dd).print();
};
const generateContentPlanifMultiple = (planifTitles, planifData) => {
  planifData.sort((a, b) => {
    return a.nom.localeCompare(b.nom);
  });
  console.log(planifTitles);
  console.log(planifData);
  let content = [];
  let tableBody = planifData.map((employe) => {
    let employeTable = [employe.nom, employe.prenom];
    planifTitles.forEach((planifTitle) => {
      let employeheure = '';
      let employeremarque = '';
      let employeheurenremarque = '';
      let color = getColor(employe[planifTitle.id][0]);
      if (employe[planifTitle.id][0] === 'CONGÉ') {
        employeheurenremarque = 'CONGÉ';
      } else if (employe[planifTitle.id][0] === 'OFF') {
        employeheurenremarque = 'OFF';
      } else {
        employe[planifTitle.id].forEach((project, index) => {
          if (index > 0) {
            employeheure += '\n';
            employeremarque += '\n';
            employeheurenremarque += '\n';
          }
          employeheure += project.depart;
          employeremarque += project.remarques.replace('.', '');
          employeheurenremarque +=
            project.depart +
            (project.remarques.replace('.', '') &&
              ' - ' + project.remarques.replace('.', ''));
        });
      }
      employeTable.push({
        text: employeheurenremarque,
        alignment: 'center',
        fillColor: color.border,
      });
    });

    return employeTable;
  });
  let columns = [
    { text: 'NOM', bold: true },
    { text: 'PRENOM', bold: true },
  ];
  //let widths = ["auto", ]
  planifTitles.forEach((column) => {
    columns.push({ text: column.date, bold: true });
  });
  content.push({
    layout: 'lightHorizontalLines',
    margin: [0, 20, 0, 0],
    table: {
      headerRows: 1,
      dontBreakRows: true,
      keepWithHeaderRows: 1,
      //widths: ['*', 50],
      body: [
        // [
        //   'NOM',
        //   'PRENOM',
        //   // 'HEURE',
        //   // 'REMARQUE',
        //   // 'MESSAGE',
        //   // { text: 'CHECK', alignment: 'center' },
        // ],
        columns,
        ...tableBody,
      ],
    },
  });
  let dd = {
    footer: function (currentPage, pageCount) {
      return {
        text: 'Page ' + currentPage.toString() + ' de ' + pageCount,
        alignment: 'right',
        margin: [20, 0],
      };
    },
    pageSize: 'LETTER',
    pageOrientation: 'landscape',
    pageMargins: [30, 30, 30, 30],
    content: content,
    defaultStyle: {
      font: 'Roboto',
    },
    styles: {},
  };
  dd.styles.symbol = { font: 'FontAwesome' };
  return dd;
};

export { generatePdf, generatePdfPlanifMultiple };
